import { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes, useSearchParams } from "react-router-dom";
import "./App.css";
// import IntercomManager from "./components/IntercomManager";
import GatedBlogRoute from "./components/GatedBlogRoute";
import GatedContentViewTracker from "./components/GatedContentViewTracker";
import ScrollToTop from "./components/ScrollToTop";
import { DarkModeProvider } from "./contexts/DarkModeContext";
import AIReceptionistExperienceBlog from "./pages/AIReceptionistExperienceBlog";
import AIReceptionistPage from "./pages/AIReceptionistPage";
import AIReceptionistPageClean from "./pages/AIReceptionistPageClean";
import BAAPage from "./pages/BAAPage";
import BackOfficeSuitePage from "./pages/BackOfficeSuitePage";
import BlogPage from "./pages/BlogPage";
import BookDemoPage from "./pages/BookDemoPage";
import ClaimSubmissionPage from "./pages/ClaimSubmissionPage";
import ContactPage from "./pages/ContactPage";
import CustomerReferencePage from "./pages/CustomerReferencePage";
import CustomerReferenceAgreementPage from "./pages/CustomerReferenceAgreementPage";
import DSOQuoteIntakePage from "./pages/DSOQuoteIntakePage";
import DeveloperApiApplicationPage from "./pages/DeveloperApiApplicationPage";
import DentalLanding from "./pages/DentalLanding";
import DentalLandingOld from "./pages/DentalLandingOld";
import DentalLandingBackup from "./pages/DentalLandingBackup";
import DentalLandingBackup2 from "./pages/DentalLandingBackup2";
import DentalLandingBackup5 from "./pages/DentalLandingBackup5";
import DentalLandingOld2 from "./pages/DentalLandingOld2";
import DSOPage from "./pages/DSOPage";
import ElisePage from "./pages/ElisePage";
import FeaturePage from "./pages/FeaturePage";
import FrontOfficeSuitePage from "./pages/FrontOfficeSuitePage";
import GeneratedVideoBlogPage from "./pages/GeneratedVideoBlogPage";
import HygieneRecallPage from "./pages/HygieneRecallPage";
import InsuranceVerificationPage from "./pages/InsuranceVerificationPage";
import IntegrationFieldsDeckPage from "./pages/IntegrationFieldsDeckPage";
import ApiDeveloperProgramDeckPage from "./pages/ApiDeveloperProgramDeckPage";
import IntegrationsPage from "./pages/IntegrationsPage";
import KimPage from "./pages/KimPage";
import MarketingCoordinatorPage from "./pages/MarketingCoordinatorPage";
import NDAPage from "./pages/NDAPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import PrivacyPolicy2026 from "./pages/PrivacyPolicy2026";
import PrivatePracticePage from "./pages/PrivatePracticePage";
import ROICalculatorPage from "./pages/ROICalculatorPage";
import RecommendedMicsPage from "./pages/RecommendedMicsPage";
import ScheduleOptimizerPage from "./pages/ScheduleOptimizerPage";
import ScratchPage from "./pages/ScratchPage";
import ScratchPage2 from "./pages/ScratchPage2";
import AlternateLanding from "./pages/AlternateLanding";
import SlideshowPage from "./pages/SlideshowPage";
import PMSSlideshowPage from "./pages/PMSSlideshowPage";
import OSSlideshowPage from "./pages/OSSlideshowPage";
import OS2SlideshowPage from "./pages/OS2SlideshowPage";
import OSV2SlideshowPage from "./pages/OSV2SlideshowPage";
import OSV3SlideshowPage from "./pages/OSV3SlideshowPage";
import OSV3SlideshowBackupPage from "./pages/OSV3SlideshowBackupPage";
import OSSlideshowV4Page from "./pages/OSSlideshowV4Page";
import OSSlideshowV4AltPage from "./pages/OSSlideshowV4AltPage";
import AIOSSlideshowPage from "./pages/AIOSSlideshowPage";
import AIOSV3SlideshowPage from "./pages/AIOSV3SlideshowPage";
import AIOSPricingDeckPage from "./pages/AIOSPricingDeckPage";
import CaseStudiesDeckPage from "./pages/CaseStudiesDeckPage";
import OSAltPricingDeckPage from "./pages/OSAltPricingDeckPage";
import OSPricingDeckPage from "./pages/OSPricingDeckPage";
import OSFixedSlideshowPage from "./pages/OSFixedSlideshowPage";
import OSTeaserSlideshowPage from "./pages/OSTeaserSlideshowPage";
import CustomerTestimonialPage from "./pages/CustomerTestimonialPage";
import TestimonialSubmitPage from "./pages/TestimonialSubmitPage";
import TestimonialPaymentSubmitPage from "./pages/TestimonialPaymentSubmitPage";
import MarketingServiceAgreementPage from "./pages/MarketingServiceAgreementPage";
import TermsOfService from "./pages/TermsOfService";
import TermsOfService2026 from "./pages/TermsOfService2026";
import OSTermsOfService from "./pages/OSTermsOfService";
import OSTermsOfServiceCI from "./pages/OSTermsOfServiceCI";
import OSPJTermsOfService from "./pages/OSPJTermsOfService";
import PMSTermsOfServiceFellows from "./pages/PMSTermsOfServiceFellows";
import UnsubscribePage from "./pages/UnsubscribePage";
import TwoWayMessagingPage from "./pages/TwoWayMessagingPage";
import VoIPPage from "./pages/VoIPPage";
import WhyAshaBlog from "./pages/WhyAshaBlog";
import BlogAfterHoursCallsOpportunity from "./pages/generated-blogs/BlogAfterHoursCallsOpportunity";
import BlogAiMythsHumanTouch from "./pages/generated-blogs/BlogAiMythsHumanTouch";
import BlogArCollectionsAgingReceivables from "./pages/generated-blogs/BlogArCollectionsAgingReceivables";
import BlogAutomatedVerificationIsntAutomated from "./pages/generated-blogs/BlogAutomatedVerificationIsntAutomated";
import BlogCaseAcceptanceRevenueLeftBehind from "./pages/generated-blogs/BlogCaseAcceptanceRevenueLeftBehind";
import BlogClaimDenialsAiScrubbing from "./pages/generated-blogs/BlogClaimDenialsAiScrubbing";
import BlogCommunicationStackTax from "./pages/generated-blogs/BlogCommunicationStackTax";
import BlogDenialManagementAppeals from "./pages/generated-blogs/BlogDenialManagementAppeals";
import BlogEmptyChairsScheduleOptimization from "./pages/generated-blogs/BlogEmptyChairsScheduleOptimization";
import BlogEobPostingAutomation from "./pages/generated-blogs/BlogEobPostingAutomation";
import BlogFiveStarReviewProblem from "./pages/generated-blogs/BlogFiveStarReviewProblem";
import BlogHygieneRecallGoldMine from "./pages/generated-blogs/BlogHygieneRecallGoldMine";
import BlogInsuranceVerificationHiddenCost from "./pages/generated-blogs/BlogInsuranceVerificationHiddenCost";
import BlogPatientBillingDoneRight from "./pages/generated-blogs/BlogPatientBillingDoneRight";
import BlogPatientIntakeFirstImpression from "./pages/generated-blogs/BlogPatientIntakeFirstImpression";
import BlogTooSmallForAiMyth from "./pages/generated-blogs/BlogTooSmallForAiMyth";
import BlogAmyAiReceptionist24x7 from "./pages/generated-blogs/BlogAmyAiReceptionist24x7";
import BlogVoiceAiPlainLanguageInsights from "./pages/generated-blogs/BlogVoiceAiPlainLanguageInsights";
import BlogSarahDenialAutoResolution from "./pages/generated-blogs/BlogSarahDenialAutoResolution";
import BlogStephanieHygieneRecallConversations from "./pages/generated-blogs/BlogStephanieHygieneRecallConversations";
import BlogLeenaAiScheduleOptimizer from "./pages/generated-blogs/BlogLeenaAiScheduleOptimizer";
import BlogKimCaseAcceptanceFollowups from "./pages/generated-blogs/BlogKimCaseAcceptanceFollowups";
import BlogMorganZeroTouchIntake from "./pages/generated-blogs/BlogMorganZeroTouchIntake";
import BlogAmandaProcedureLevelVerification from "./pages/generated-blogs/BlogAmandaProcedureLevelVerification";
import BlogTrishaAutonomousMorningTriage from "./pages/generated-blogs/BlogTrishaAutonomousMorningTriage";
import BlogJosephAiFaxManager from "./pages/generated-blogs/BlogJosephAiFaxManager";
import BlogElenaPreSubmissionScrubbing from "./pages/generated-blogs/BlogElenaPreSubmissionScrubbing";
import BlogAliciaPaymentPostingUnderpayments from "./pages/generated-blogs/BlogAliciaPaymentPostingUnderpayments";
import BlogRachelTonematchedCollections from "./pages/generated-blogs/BlogRachelTonematchedCollections";
import BlogNorahBankReconciliation from "./pages/generated-blogs/BlogNorahBankReconciliation";
import BlogUnifiedPatientTimeline from "./pages/generated-blogs/BlogUnifiedPatientTimeline";
import BlogAiNativeCallIntelligence from "./pages/generated-blogs/BlogAiNativeCallIntelligence";
import BlogClinicallyAwarePatientGroups from "./pages/generated-blogs/BlogClinicallyAwarePatientGroups";
import BlogInternalHubChartContext from "./pages/generated-blogs/BlogInternalHubChartContext";
import BlogInOfficePaymentsUnified from "./pages/generated-blogs/BlogInOfficePaymentsUnified";
import BlogTextToPayInstantStatements from "./pages/generated-blogs/BlogTextToPayInstantStatements";
import BlogMobileFirstPatientForms from "./pages/generated-blogs/BlogMobileFirstPatientForms";
import BlogAshaAIIntro from "./pages/generated-blogs/BlogAshaAIIntro";
import BlogAlishaEobPosting from "./pages/generated-blogs/BlogAlishaEobPosting";
import BlogSarahDenialManagement from "./pages/generated-blogs/BlogSarahDenialManagement";
import BlogEndToEndPatientJourney from "./pages/generated-blogs/BlogEndToEndPatientJourney";
import BlogTryAIReceptionistSandbox from "./pages/generated-blogs/BlogTryAIReceptionistSandbox";
import BlogAIClaimSubmissionSkills from "./pages/generated-blogs/BlogAIClaimSubmissionSkills";

import MorganPatientIntakePage from "./pages/MorganPatientIntakePage";
import LauraInsuranceCallsPage from "./pages/LauraInsuranceCallsPage";
import AlaynaClaimScrubbingPage from "./pages/AlaynaClaimScrubbingPage";
import AlishaEOBPostingPage from "./pages/AlishaEOBPostingPage";
import SarahDenialManagementPage from "./pages/SarahDenialManagementPage";
import KiannaPatientBillingPage from "./pages/KiannaPatientBillingPage";
import JuliaARCollectionsPage from "./pages/JuliaARCollectionsPage";
import EFaxPage from "./pages/EFaxPage";
import PatientRemindersPage from "./pages/PatientRemindersPage";
import ScheduleDemoPage from "./pages/ScheduleDemoPage";
import NotFoundPage from "./pages/NotFoundPage";
import OnboardingGuidePage from "./pages/OnboardingGuidePage";
import OnboardingGuideDetailedPage from "./pages/OnboardingGuideDetailedPage";
import OnsiteTrainingPricingPage from "./pages/OnsiteTrainingPricingPage";
import OffboardingGuidePage from "./pages/OffboardingGuidePage";
import ExpectationsGuidePage from "./pages/ExpectationsGuidePage";
import MobileAdPage from "./pages/MobileAdPage";
import MobileAdV3Page from "./pages/MobileAdV3Page";
import MobileAdV4Page from "./pages/MobileAdV4Page";
import MobileAdV5Page from "./pages/MobileAdV5Page";
import MobileAdV6Page from "./pages/MobileAdV6Page";
import AdLabPage from "./pages/AdLabPage";
import DrGressellPage from "./pages/DrGressellPage";
import DrGressellQrPage from "./pages/DrGressellQrPage";
import QuotePage from "./pages/QuotePage";
import OfferPage from "./pages/OfferPage";
import OsFeesPage from "./pages/OsFeesPage";
import OsFeesAtw32351Page from "./pages/OsFeesAtw32351Page";
import OsFeesRtge324Page from "./pages/OsFeesRtge324Page";
import OsFeesYer2453Page from "./pages/OsFeesYer2453Page";
import OsFeesEr235Page from "./pages/OsFeesEr235Page";
import OsFeesQrx5168Page from "./pages/OsFeesQrx5168Page";
import OsFeesPmsPage from "./pages/OsFeesPmsPage";
import OsFeesCiPage from "./pages/OsFeesCiPage";
import OsFeesComparisonPage from "./pages/OsFeesComparisonPage";
import OsFees5LocPage from "./pages/OsFees5LocPage";
import OsFees1LocPage from "./pages/OsFees1LocPage";
import OsFees1LocFellowsPage from "./pages/OsFees1LocFellowsPage";
import OsFees2To4LocPage from "./pages/OsFees2To4LocPage";
import Asha360DeckPage from "./pages/Asha360DeckPage";
import AbrahamDeckPage from "./pages/AbrahamDeckPage";
import SpaCreekDeckPage from "./pages/SpaCreekDeckPage";
import FrankChenDeckPage from "./pages/FrankChenDeckPage";
import AIFellowsPage from "./pages/AIFellowsPage";
import AIFellowsProgramPage from "./pages/AIFellowsProgramPage";
import AIFellowsApplicationPage from "./pages/AIFellowsApplicationPage";
import AITransformationDrSmithPage from "./pages/AITransformationDrSmithPage";
import ExperimentalLanding from "./pages/ExperimentalLanding";
import ExperimentalLanding2 from "./pages/ExperimentalLanding2";
import AlternateLanding2 from "./pages/AlternateLanding2";
import AlternateLanding3 from "./pages/AlternateLanding3";
import Alt4Home from "./alt4/pages/Alt4Home";
import Alt4Platform from "./alt4/pages/Alt4Platform";
import Alt4Autopilot from "./alt4/pages/Alt4Autopilot";
import Alt4Workflows from "./alt4/pages/Alt4Workflows";
import Alt4Practices from "./alt4/pages/Alt4Practices";
import Alt4Migration from "./alt4/pages/Alt4Migration";
import Alt4Walkthrough from "./alt4/pages/Alt4Walkthrough";
import Alt6Home from "./alt6/pages/Alt6Home";
import Alt6Platform from "./alt6/pages/Alt6Platform";
import Alt6Autopilot from "./alt6/pages/Alt6Autopilot";
import Alt6Journey from "./alt6/pages/Alt6Journey";
import Alt6Switching from "./alt6/pages/Alt6Switching";
import Alt6WhyAsha from "./alt6/pages/Alt6WhyAsha";
import Alt6Demo from "./alt6/pages/Alt6Demo";
import Alt6Start from "./alt6/pages/Alt6Start";
import V2Home from "./v2/pages/V2Home";
import V2Platform from "./v2/pages/V2Platform";
import V2AiTeam from "./v2/pages/V2AiTeam";
import V2FrontOffice from "./v2/pages/V2FrontOffice";
import V2RevenueCycle from "./v2/pages/V2RevenueCycle";
import V2ClinicalAi from "./v2/pages/V2ClinicalAi";
import V2Switch from "./v2/pages/V2Switch";
import V2Communications from "./v2/pages/V2Communications";
import V2Aria from "./v2/pages/V2Aria";
import V2WhyAsha from "./v2/pages/V2WhyAsha";

const TRUST_CENTER_URL = "https://trust.oneleet.com/asha-health";

function ExternalRedirect({ to }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return null;
}

function BackupGate() {
  const [searchParams] = useSearchParams();
  if (searchParams.get("key") !== "asha-snapshot-2026-04-19") {
    return <NotFoundPage />;
  }
  return <OSV3SlideshowBackupPage />;
}

function OSV3Gate() {
  const [searchParams] = useSearchParams();
  if (searchParams.get("key") !== "asha-os-backup-2026-04-21") {
    return <NotFoundPage />;
  }
  return <OSV3SlideshowPage />;
}

function App() {
  // Domain-based display mode:
  // - vercel.app, asha.health → slideshow only
  // - asha.dental, localhost, etc → full website
  const hostname =
    typeof window !== "undefined" ? window.location.hostname : "";

  const isSlideshowOnly =
    hostname.includes("vercel.app") || hostname.includes("asha.health");

  // Internal-only pages: render 404 everywhere except local dev
  const isLocalDev = hostname === "localhost" || hostname === "127.0.0.1";

  // Experimental/alternate site iterations (alt*, v2, old*) — kept out of prod
  // but still reachable in local dev for continued design iteration.
  const hideInProd = (element) => (isLocalDev ? element : <NotFoundPage />);

  return (
    <DarkModeProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <GatedContentViewTracker />
          {/* <IntercomManager /> */}
          <Routes>
            {isSlideshowOnly ? (
              <>
                <Route path="/slideshow" element={<SlideshowPage />} />
                <Route path="/offer/:id" element={<OfferPage />} />
                <Route path="/unsubscribe" element={<UnsubscribePage />} />
                <Route
                  path="*"
                  element={<Navigate to="/slideshow" replace />}
                />
              </>
            ) : (
              <>
                <Route path="/" element={<DentalLanding />} />
                {/* alt / v2 / old experimental iterations, hidden in prod (local dev only) */}
                <Route path="/alt2" element={hideInProd(<AlternateLanding2 />)} />
                <Route path="/alt3" element={hideInProd(<AlternateLanding3 />)} />
                <Route path="/alt4" element={hideInProd(<Alt4Home />)} />
                <Route path="/alt4/platform" element={hideInProd(<Alt4Platform />)} />
                <Route path="/alt4/autopilot" element={hideInProd(<Alt4Autopilot />)} />
                <Route path="/alt4/workflows" element={hideInProd(<Alt4Workflows />)} />
                <Route path="/alt4/practices" element={hideInProd(<Alt4Practices />)} />
                <Route path="/alt4/migration" element={hideInProd(<Alt4Migration />)} />
                <Route path="/alt4/walkthrough" element={hideInProd(<Alt4Walkthrough />)} />
                <Route path="/alt6" element={hideInProd(<Alt6Home />)} />
                <Route path="/alt6/platform" element={hideInProd(<Alt6Platform />)} />
                <Route path="/alt6/autopilot" element={hideInProd(<Alt6Autopilot />)} />
                <Route path="/alt6/patient-journey" element={hideInProd(<Alt6Journey />)} />
                <Route path="/alt6/switching" element={hideInProd(<Alt6Switching />)} />
                <Route path="/alt6/why-asha" element={hideInProd(<Alt6WhyAsha />)} />
                <Route path="/alt6/demo" element={hideInProd(<Alt6Demo />)} />
                <Route path="/alt6/start" element={hideInProd(<Alt6Start />)} />
                <Route path="/experimental" element={<NotFoundPage />} />
                <Route path="/experimental-2" element={<NotFoundPage />} />
                <Route path="/v2" element={hideInProd(<V2Home />)} />
                <Route path="/v2/platform" element={hideInProd(<V2Platform />)} />
                <Route path="/v2/ai-team" element={hideInProd(<V2AiTeam />)} />
                <Route path="/v2/front-office" element={hideInProd(<V2FrontOffice />)} />
                <Route path="/v2/revenue-cycle" element={hideInProd(<V2RevenueCycle />)} />
                <Route path="/v2/clinical-ai" element={hideInProd(<V2ClinicalAi />)} />
                <Route path="/v2/switch" element={hideInProd(<V2Switch />)} />
                <Route path="/v2/communications" element={hideInProd(<V2Communications />)} />
                <Route path="/v2/aria" element={hideInProd(<V2Aria />)} />
                <Route path="/v2/why-asha" element={hideInProd(<V2WhyAsha />)} />
                <Route path="/old" element={hideInProd(<DentalLandingOld />)} />
                <Route path="/old2" element={hideInProd(<DentalLandingOld2 />)} />
                <Route path="/book-demo" element={<BookDemoPage />} />
                <Route path="/schedule-demo" element={<ScheduleDemoPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/customer-reference" element={<CustomerReferencePage />} />
                <Route path="/customer-reference-agreement" element={<CustomerReferenceAgreementPage />} />
                <Route path="/dso-quote-intake" element={<DSOQuoteIntakePage />} />
                <Route path="/developer-api-application" element={<DeveloperApiApplicationPage />} />
                <Route path="/api-developer-application" element={<DeveloperApiApplicationPage />} />
                {/* Internal/dev routes - show 404 to public but keep code */}
                <Route path="/backup" element={<NotFoundPage />} />
                <Route path="/backup5" element={<DentalLandingBackup5 />} />
                <Route path="/landingbackup2" element={<NotFoundPage />} />
                <Route path="/featurepage" element={<NotFoundPage />} />
                <Route path="/agents/receptionist-old" element={<NotFoundPage />} />
                <Route path="/scratch" element={<NotFoundPage />} />
                <Route path="/scratch2" element={<NotFoundPage />} />
                <Route path="/alternate-landing" element={<NotFoundPage />} />
                {/* End internal/dev routes */}
                <Route path="/blog" element={<BlogPage />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/privacy-policy-2026" element={<PrivacyPolicy2026 />} />
                <Route path="/trust" element={<ExternalRedirect to={TRUST_CENTER_URL} />} />
                <Route path="/trust-center" element={<ExternalRedirect to={TRUST_CENTER_URL} />} />
                <Route path="/security" element={<ExternalRedirect to={TRUST_CENTER_URL} />} />
                <Route path="/terms-of-service" element={<TermsOfService />} />
                <Route path="/terms-of-service-2026" element={<TermsOfService2026 />} />
                <Route path="/os-tos" element={<OSTermsOfService />} />
                <Route path="/os-tos-ci" element={<OSTermsOfServiceCI />} />
                <Route path="/os-pj-tos" element={<OSPJTermsOfService />} />
                <Route path="/pms-tos-fellows" element={<PMSTermsOfServiceFellows />} />
                <Route path="/unsubscribe" element={<UnsubscribePage />} />
                <Route path="/baa" element={<BAAPage />} />
                <Route path="/nda" element={<NDAPage />} />
                <Route
                  path="/agents/patient-intake"
                  element={<MorganPatientIntakePage />}
                />
                <Route
                  path="/agents/receptionist"
                  element={<AIReceptionistPageClean />}
                />
                <Route
                  path="/agents/marketing-coordinator"
                  element={<MarketingCoordinatorPage />}
                />
                <Route
                  path="/solutions/front-office-suite"
                  element={<FrontOfficeSuitePage />}
                />
                <Route
                  path="/solutions/back-office-suite"
                  element={<BackOfficeSuitePage />}
                />
                <Route
                  path="/solutions/private-practices"
                  element={<PrivatePracticePage />}
                />
                <Route path="/solutions/dsos" element={<DSOPage />} />
                <Route
                  path="/agents/schedule-optimizer"
                  element={<ScheduleOptimizerPage />}
                />
                <Route
                  path="/agents/hygiene-recall"
                  element={<HygieneRecallPage />}
                />
                <Route
                  path="/agents/patient-experience"
                  element={<ElisePage />}
                />
                <Route path="/agents/case-acceptance" element={<KimPage />} />
                <Route
                  path="/agents/insurance-verification"
                  element={<InsuranceVerificationPage />}
                />
                <Route
                  path="/agents/insurance-calls"
                  element={<LauraInsuranceCallsPage />}
                />
                <Route
                  path="/agents/claim-submission"
                  element={<ClaimSubmissionPage />}
                />
                <Route
                  path="/agents/claim-scrubbing"
                  element={<AlaynaClaimScrubbingPage />}
                />
                <Route
                  path="/agents/eob-posting"
                  element={<AlishaEOBPostingPage />}
                />
                <Route
                  path="/agents/denial-management"
                  element={<SarahDenialManagementPage />}
                />
                <Route
                  path="/agents/patient-billing"
                  element={<KiannaPatientBillingPage />}
                />
                <Route
                  path="/agents/ar-collections"
                  element={<JuliaARCollectionsPage />}
                />
                <Route path="/migrations" element={<IntegrationsPage />} />
                <Route path="/integrations" element={<IntegrationsPage />} />
                <Route path="/recommended-mics" element={<RecommendedMicsPage />} />
                <Route path="/comms-suite/voip" element={<VoIPPage />} />
                <Route
                  path="/comms-suite/efax"
                  element={<EFaxPage />}
                />
                <Route
                  path="/comms-suite/reminders"
                  element={<PatientRemindersPage />}
                />
                <Route
                  path="/comms-suite/messaging"
                  element={<TwoWayMessagingPage />}
                />
                <Route
                  path="/blog/patient-experience-ai-receptionist"
                  element={<GatedBlogRoute><AIReceptionistExperienceBlog /></GatedBlogRoute>}
                />
                <Route path="/blog/why-asha" element={<GatedBlogRoute><WhyAshaBlog /></GatedBlogRoute>} />
                <Route path="/blog/insurance-verification-hidden-cost" element={<GatedBlogRoute><BlogInsuranceVerificationHiddenCost /></GatedBlogRoute>} />
                <Route path="/blog/claim-denials-ai-scrubbing" element={<GatedBlogRoute><BlogClaimDenialsAiScrubbing /></GatedBlogRoute>} />
                <Route path="/blog/eob-posting-automation" element={<GatedBlogRoute><BlogEobPostingAutomation /></GatedBlogRoute>} />
                <Route path="/blog/empty-chairs-schedule-optimization" element={<GatedBlogRoute><BlogEmptyChairsScheduleOptimization /></GatedBlogRoute>} />
                <Route path="/blog/hygiene-recall-gold-mine" element={<GatedBlogRoute><BlogHygieneRecallGoldMine /></GatedBlogRoute>} />
                <Route path="/blog/ai-myths-human-touch" element={<GatedBlogRoute><BlogAiMythsHumanTouch /></GatedBlogRoute>} />
                <Route path="/blog/after-hours-calls-opportunity" element={<GatedBlogRoute><BlogAfterHoursCallsOpportunity /></GatedBlogRoute>} />
                <Route path="/blog/patient-billing-done-right" element={<GatedBlogRoute><BlogPatientBillingDoneRight /></GatedBlogRoute>} />
                <Route path="/blog/ar-collections-aging-receivables" element={<GatedBlogRoute><BlogArCollectionsAgingReceivables /></GatedBlogRoute>} />
                <Route path="/blog/denial-management-appeals" element={<GatedBlogRoute><BlogDenialManagementAppeals /></GatedBlogRoute>} />
                <Route path="/blog/patient-intake-first-impression" element={<GatedBlogRoute><BlogPatientIntakeFirstImpression /></GatedBlogRoute>} />
                <Route path="/blog/case-acceptance-revenue-left-behind" element={<GatedBlogRoute><BlogCaseAcceptanceRevenueLeftBehind /></GatedBlogRoute>} />
                <Route path="/blog/too-small-for-ai-myth" element={<GatedBlogRoute><BlogTooSmallForAiMyth /></GatedBlogRoute>} />
                <Route path="/blog/automated-verification-isnt-automated" element={<GatedBlogRoute><BlogAutomatedVerificationIsntAutomated /></GatedBlogRoute>} />
                <Route path="/blog/communication-stack-tax" element={<GatedBlogRoute><BlogCommunicationStackTax /></GatedBlogRoute>} />
                <Route path="/blog/five-star-review-problem" element={<GatedBlogRoute><BlogFiveStarReviewProblem /></GatedBlogRoute>} />
                <Route path="/blog/amy-ai-receptionist-24x7" element={<GatedBlogRoute><BlogAmyAiReceptionist24x7 /></GatedBlogRoute>} />
                <Route path="/blog/voice-ai-plain-language-insights" element={<GatedBlogRoute><BlogVoiceAiPlainLanguageInsights /></GatedBlogRoute>} />
                <Route path="/blog/sarah-denial-auto-resolution" element={<GatedBlogRoute><BlogSarahDenialAutoResolution /></GatedBlogRoute>} />
                <Route path="/blog/stephanie-hygiene-recall-conversations" element={<GatedBlogRoute><BlogStephanieHygieneRecallConversations /></GatedBlogRoute>} />
                <Route path="/blog/leena-ai-schedule-optimizer" element={<GatedBlogRoute><BlogLeenaAiScheduleOptimizer /></GatedBlogRoute>} />
                <Route path="/blog/kim-case-acceptance-followups" element={<GatedBlogRoute><BlogKimCaseAcceptanceFollowups /></GatedBlogRoute>} />
                <Route path="/blog/morgan-zero-touch-patient-intake" element={<GatedBlogRoute><BlogMorganZeroTouchIntake /></GatedBlogRoute>} />
                <Route path="/blog/amanda-procedure-level-verification" element={<GatedBlogRoute><BlogAmandaProcedureLevelVerification /></GatedBlogRoute>} />
                <Route path="/blog/trisha-autonomous-morning-triage" element={<GatedBlogRoute><BlogTrishaAutonomousMorningTriage /></GatedBlogRoute>} />
                <Route path="/blog/joseph-ai-fax-manager" element={<GatedBlogRoute><BlogJosephAiFaxManager /></GatedBlogRoute>} />
                <Route path="/blog/elena-pre-submission-claim-scrubbing" element={<GatedBlogRoute><BlogElenaPreSubmissionScrubbing /></GatedBlogRoute>} />
                <Route path="/blog/alicia-payment-posting-underpayments" element={<GatedBlogRoute><BlogAliciaPaymentPostingUnderpayments /></GatedBlogRoute>} />
                <Route path="/blog/rachel-tone-matched-collections" element={<GatedBlogRoute><BlogRachelTonematchedCollections /></GatedBlogRoute>} />
                <Route path="/blog/norah-bank-reconciliation" element={<GatedBlogRoute><BlogNorahBankReconciliation /></GatedBlogRoute>} />
                <Route path="/blog/unified-patient-communication-timeline" element={<GatedBlogRoute><BlogUnifiedPatientTimeline /></GatedBlogRoute>} />
                <Route path="/blog/ai-native-call-intelligence" element={<GatedBlogRoute><BlogAiNativeCallIntelligence /></GatedBlogRoute>} />
                <Route path="/blog/clinically-aware-patient-groups" element={<GatedBlogRoute><BlogClinicallyAwarePatientGroups /></GatedBlogRoute>} />
                <Route path="/blog/internal-hub-chart-context" element={<GatedBlogRoute><BlogInternalHubChartContext /></GatedBlogRoute>} />
                <Route path="/blog/in-office-payments-unified-ledger" element={<GatedBlogRoute><BlogInOfficePaymentsUnified /></GatedBlogRoute>} />
                <Route path="/blog/text-to-pay-instant-statements" element={<GatedBlogRoute><BlogTextToPayInstantStatements /></GatedBlogRoute>} />
                <Route path="/blog/mobile-first-patient-forms" element={<GatedBlogRoute><BlogMobileFirstPatientForms /></GatedBlogRoute>} />
                <Route path="/blog/asha-ai-intro" element={<GatedBlogRoute contentType="video"><BlogAshaAIIntro /></GatedBlogRoute>} />
                <Route path="/blog/alisha-eob-posting" element={<GatedBlogRoute contentType="video"><BlogAlishaEobPosting /></GatedBlogRoute>} />
                <Route path="/blog/sarah-denial-management" element={<GatedBlogRoute contentType="video"><BlogSarahDenialManagement /></GatedBlogRoute>} />
                <Route path="/blog/end-to-end-patient-journey" element={<GatedBlogRoute contentType="video"><BlogEndToEndPatientJourney /></GatedBlogRoute>} />
                <Route path="/blog/try-ai-receptionist-sandbox" element={<GatedBlogRoute contentType="video"><BlogTryAIReceptionistSandbox /></GatedBlogRoute>} />
                <Route path="/blog/ai-claim-submission-skills" element={<GatedBlogRoute contentType="video"><BlogAIClaimSubmissionSkills /></GatedBlogRoute>} />
                <Route path="/blog/:slug" element={<GatedBlogRoute contentType="video"><GeneratedVideoBlogPage /></GatedBlogRoute>} />
                <Route
                  path="/onboarding-guide"
                  element={<OnboardingGuidePage />}
                />
                <Route
                  path="/onboarding-guide-detailed"
                  element={<OnboardingGuideDetailedPage />}
                />
                <Route
                  path="/onsite-training-pricing"
                  element={<OnsiteTrainingPricingPage />}
                />
                <Route
                  path="/offboarding-guide"
                  element={<OffboardingGuidePage />}
                />
                <Route
                  path="/off-boarding-guide"
                  element={<OffboardingGuidePage />}
                />
                <Route
                  path="/expectations-guide"
                  element={<ExpectationsGuidePage />}
                />
                <Route path="/roi-calculator" element={<ROICalculatorPage />} />
                <Route path="/slideshow" element={<NotFoundPage />} />
                <Route path="/pms" element={<NotFoundPage />} />
                <Route path="/os" element={<OSSlideshowV4Page />} />
                <Route path="/os-pricing" element={<OSPricingDeckPage />} />
                <Route path="/os-alt" element={<OSSlideshowV4AltPage />} />
                <Route path="/os-alt-pricing" element={<OSAltPricingDeckPage />} />
                <Route path="/ai-os" element={<AIOSSlideshowPage />} />
                <Route path="/ai-os-v3" element={<AIOSV3SlideshowPage />} />
                <Route path="/ai-os-pricing" element={<AIOSPricingDeckPage />} />
                <Route path="/case-studies" element={<CaseStudiesDeckPage />} />
                <Route path="/ai-rcm" element={<AIOSSlideshowPage />} />
                <Route path="/integration-fields" element={<IntegrationFieldsDeckPage />} />
                <Route path="/api-developer-program" element={<ApiDeveloperProgramDeckPage />} />
                <Route path="/api-program" element={<ApiDeveloperProgramDeckPage />} />
                <Route path="/os-1" element={<OSSlideshowV4Page excludePractices={["Klein Family Dentistry"]} />} />
                <Route path="/os-2" element={<OS2SlideshowPage />} />
                <Route path="/os-v2" element={<NotFoundPage />} />
                {/* OS backup — original OS V3 deck, gated so it's not public */}
                <Route path="/os-v3" element={<OSV3Gate />} />
                <Route path="/os-v3-backup" element={<BackupGate />} />
                <Route path="/os-fixed" element={<OSFixedSlideshowPage />} />
                <Route path="/os-teaser" element={<OSTeaserSlideshowPage />} />
                <Route path="/customer-testimonial" element={<CustomerTestimonialPage />} />
                <Route path="/customer-testimonial/submit" element={<TestimonialSubmitPage />} />
                <Route path="/testimonial-payment" element={<TestimonialPaymentSubmitPage />} />
                <Route path="/marketing-service-agreement" element={<MarketingServiceAgreementPage />} />
                <Route path="/mobile-ad" element={<MobileAdPage />} />
                <Route path="/mobile-ad-v3" element={<MobileAdV3Page />} />
                <Route path="/mobile-ad-v4" element={<MobileAdV4Page />} />
                <Route path="/mobile-ad-v5" element={<MobileAdV5Page />} />
                <Route path="/mobile-ad-v6" element={<MobileAdV6Page />} />
                <Route path="/ad-lab" element={isLocalDev ? <AdLabPage /> : <NotFoundPage />} />
                <Route path="/fellow/dr-gressell" element={<DrGressellPage />} />
                <Route path="/fellow/dr-gressel" element={<DrGressellPage />} />
                <Route path="/fellow/dr-gressell/qr" element={<DrGressellQrPage />} />
                <Route path="/ai-fellows" element={<AIFellowsPage />} />
                <Route path="/ai-fellows-program" element={<AIFellowsProgramPage />} />
                <Route path="/ai-fellows-application" element={<AIFellowsApplicationPage />} />
                <Route path="/ai-transformation-dr-smith" element={<AITransformationDrSmithPage />} />
                <Route path="/quote/:id" element={<QuotePage />} />
                <Route path="/offer/:id" element={<OfferPage />} />
                <Route path="/os-fees" element={<OsFeesPage />} />
                <Route path="/os-fees-atw32351" element={<OsFeesAtw32351Page />} />
                <Route path="/os-fees-rtge324" element={<OsFeesRtge324Page />} />
                <Route path="/os-fees-yer2453" element={<OsFeesYer2453Page />} />
                <Route path="/os-fees-er235" element={<OsFeesEr235Page />} />
                <Route path="/os-fees-qrx5168" element={<OsFeesQrx5168Page />} />
                <Route path="/os-fees-pms" element={<OsFeesPmsPage />} />
                <Route path="/os-fees-ci" element={<OsFeesCiPage />} />
                <Route path="/os-fees-comparison" element={<OsFeesComparisonPage />} />
                <Route path="/os-fees-5loc" element={<OsFees5LocPage />} />
                <Route path="/os-fees-1loc" element={<OsFees1LocPage />} />
                <Route path="/os-fees-1loc-fellows" element={<OsFees1LocFellowsPage />} />
                <Route path="/os-fees-2to4loc" element={<OsFees2To4LocPage />} />
                <Route path="/quote/360-dental" element={<Asha360DeckPage />} />
                <Route path="/quote/abraham" element={<AbrahamDeckPage />} />
                <Route path="/quote/spa-creek" element={<SpaCreekDeckPage />} />
                <Route path="/quote/frank-chen" element={<FrankChenDeckPage />} />
                {/* Catch-all 404 for any unmatched routes */}
                <Route path="*" element={<NotFoundPage />} />
              </>
            )}
          </Routes>
        </BrowserRouter>
      </div>
    </DarkModeProvider>
  );
}

export default App;
